import styled from 'styled-components/macro';

const CounterText = styled.div`
  padding: 0 24px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
`;

export default CounterText;
